var _g, _path, _circle, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 141,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M84.299 136.382c32.032 0 58-25.967 58-58 0-32.032-25.968-58-58-58-32.033 0-58 25.968-58 58 0 32.033 25.967 58 58 58Z",
    fill: "#D4FEED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 79,
    r: 41,
    fill: "#62CBA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.592 66.561a4.1 4.1 0 0 1-.05 5.798L82.077 91.493a4.1 4.1 0 0 1-5.748 0l-7.869-7.735a4.1 4.1 0 0 1 5.749-5.848l4.994 4.91 16.59-16.308a4.1 4.1 0 0 1 5.799.05Z",
    fill: "#F8F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.593 141.277c-9.21 0-18.377-2.058-26.934-6.144-15.09-7.206-26.47-19.858-32.046-35.625-5.574-15.766-4.675-32.759 2.531-47.85 7.206-15.09 19.858-26.47 35.624-32.045 15.765-5.574 32.759-4.675 47.849 2.531 7.125 3.403 13.445 8.028 18.787 13.75a.288.288 0 1 1-.422.392c-5.291-5.67-11.553-10.252-18.613-13.623-30.864-14.739-67.966-1.621-82.706 29.243-14.74 30.865-1.621 67.967 29.243 82.707 14.952 7.14 31.789 8.031 47.41 2.508 15.621-5.523 28.157-16.8 35.297-31.751 3.25-6.807 5.219-14.035 5.849-21.483a.284.284 0 0 1 .311-.262.287.287 0 0 1 .262.31 62.362 62.362 0 0 1-5.904 21.683c-7.206 15.091-19.859 26.472-35.624 32.046-6.825 2.412-13.882 3.613-20.914 3.613Z",
    fill: "#323232"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.34 29.803c-.258-1.07-1.782-1.07-2.04 0l-.335 1.388a1.05 1.05 0 0 1-.774.774l-1.388.335c-1.071.259-1.071 1.782 0 2.04l1.388.336c.383.092.681.391.774.774l.335 1.387c.258 1.072 1.782 1.072 2.04 0l.336-1.387a1.05 1.05 0 0 1 .774-.774l1.387-.335c1.071-.259 1.071-1.782 0-2.041l-1.387-.335a1.05 1.05 0 0 1-.774-.774l-.335-1.388ZM149.341 109.803c-.259-1.071-1.783-1.071-2.041 0l-.335 1.388a1.05 1.05 0 0 1-.774.774l-1.388.335c-1.071.259-1.071 1.782 0 2.041l1.388.335c.383.092.681.391.774.774l.335 1.387c.258 1.072 1.782 1.072 2.041 0l.335-1.387c.092-.383.391-.682.774-.774l1.387-.335c1.071-.259 1.071-1.782 0-2.041l-1.387-.335a1.048 1.048 0 0 1-.774-.774l-.335-1.388Z",
    fill: "#323232"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.998,
    cy: 16.998,
    r: 2.498,
    stroke: "#323232"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.998,
    cy: 128.998,
    r: 2.998,
    fill: "#62CBA5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h159v141H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.9e2f27b2deddb25631a13513cf22e06a.svg";
export { ForwardRef as ReactComponent };